import { fork } from 'redux-saga/effects';
import { watchAuth } from '../auth';
import { watchQuestions } from '../questions';
import { watchSettings } from '../settings';
import { watchPopularDestinations } from '../popularDestinations';
import { watchOffers } from '../offers';
import { watchContacts } from '../contactUs';
import { watchSuggestions } from 'store/suggestions';

/** Combined Sagas */
export const appSaga = function* startForman() {
  yield fork(watchAuth);
  yield fork(watchQuestions);
  yield fork(watchSettings);
  yield fork(watchPopularDestinations);
  yield fork(watchOffers);
  yield fork(watchContacts);
  yield fork(watchSuggestions);
};
